var _script, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaVedomosti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "260.000000pt",
    height: "260.000000pt",
    viewBox: "0 0 260.000000 260.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    async: "false",
    type: "text/javascript",
    src: "moz-extension://33d4f970-0f6d-4e56-ae9a-a8614e04c84f/in-page.js"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.11, written by Peter Selinger 2001-2013\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,260.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690 2080 l0 -40 60 0 60 0 0 -725 0 -725 -60 0 -60 0 0 -35 0 -35 418 0 c459 0 490 3 603 61 121 61 194 153 225 285 40 172 -14 313 -157 404 -56 37 -155 70 -206 70 -51 0 -36 21 27 37 143 36 231 139 260 303 37 209 -87 377 -317 425 -52 11 -159 15 -460 15 l-393 0 0 -40z m723 -60 c40 -31 47 -77 47 -290 0 -214 -8 -259 -50 -302 -25 -25 -36 -28 -89 -28 l-61 0 0 320 0 320 64 0 c49 0 69 -5 89 -20z m-3 -723 c30 -16 51 -37 68 -68 23 -43 23 -48 20 -289 -3 -212 -5 -249 -21 -277 -27 -50 -59 -65 -143 -71 l-74 -5 0 367 0 366 53 0 c37 0 68 -7 97 -23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaVedomosti);
export default __webpack_public_path__ + "static/media/media_vedomosti.538fedabdedc121334aa42226c353f02.svg";
export { ForwardRef as ReactComponent };